module.exports = __webpack_public_path__ + "img/gasoline.5970937c.svg";